import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'
import type { SharedProps } from '@/types'

let started = false

export function initAnalytics(props: SharedProps) {
  if (started) return
  started = true
  const { config, auth } = props
  if (config.sentry_dsn) {
    Sentry.init({ dsn: config.sentry_dsn, sendDefaultPii: false })
    if (auth) Sentry.setUser({ id: String(auth.user.id) })
  }
  if (config.posthog_key) {
    posthog.init(config.posthog_key, { api_host: config.posthog_host, capture_pageview: 'history_change', person_profiles: 'identified_only' })
    if (auth) posthog.identify(String(auth.user.id), { email: auth.user.email })
  }
}

export function identify(props: SharedProps) {
  if (props.auth && props.config.posthog_key) posthog.identify(String(props.auth.user.id), { email: props.auth.user.email })
}

export function track(event: string, properties: Record<string, unknown> = {}) {
  if (started && posthog.__loaded) posthog.capture(event, properties)
}
